import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@checkout-s/Skeleton';
import Translation from '@checkout-s/Translation';

const ChangeDateButton = props => {
    return (
        <button
            className="child__event__change-date button--link"
            onClick={props.onClick}><Translation>{'checkout__change_date'}</Translation>
            <span className="sr-only">from {props.displayDate}</span>
        </button>
    );
}

class ChangeDate extends Component {

    render() {

        if (this.props.isKiosk) {
            return(
                <div className="kiosk__change-date">
                    <button className="change-date" onClick={this.props.onClick}>
                        <div className="change-date__left">
                            <i className="change-date__cal-icon icon-calendar_today" aria-hidden="true"></i>
                            {this.props.displayDate ?
                                <span className="change-date__date">{this.props.displayDate}</span>
                                :
                                <Skeleton
                                    height="30px"
                                    width="237px"
                                    borderRadius="0"
                                    marginBottom="0"
                                    display="block"
                                />
                            }
                        </div>
                        {!this.props.hideChangeButton && (
                            <div className="change-date__right">
                                <span className="change-date__change">
                                    <Translation>{'checkout__change'}</Translation>
                                    <i className="icon-keyboard_arrow_down" aria-hidden="true"></i>
                                </span>
                            </div>
                        )}
                    </button>
                    <span className="kiosk__change-date__remaining">{this.props.lowInventoryMessage}</span>
                </div>
            )
        }

        return(
            <div className="checkout__change-date child__event__info card">
                <div className="child__event__info-card">
                    <span className="child__event__selected-date-time">
                        {this.props.displayDate}
                    </span>
                    {this.props.seriesChildAdditionalInfo
                      ?
                      <div className="series-child-additional-info message message__inline-text">
                            <span className="message__icon">
                              <i className="icon-info_outline" aria-hidden="true"></i>
                            </span>
                        <span className="message__text">
                              {this.props.seriesChildAdditionalInfo}
                            </span>
                      </div>
                      :
                      <div></div>
                    }
                    {!this.props.hideChangeButton && <ChangeDateButton onClick={this.props.onClick} displayDate={this.props.displayDate} />}
                </div>
            </div>
        )
    }

}

ChangeDate.Button = ChangeDateButton;

ChangeDate.propTypes = {
    onClick: PropTypes.func.isRequired,
    displayDate: PropTypes.string,
    hideChangeButton: PropTypes.bool,
    seriesChildAdditionalInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null]),]),
}

ChangeDateButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    displayDate: PropTypes.string,
}

export default ChangeDate;
